const LinkComponent = (props) => {
    const {question} = props;
    return (
        
        <div dangerouslySetInnerHTML={{ __html: question.text }}></div>
       
    );
  }
  export default LinkComponent;